import React, { useState } from 'react'
import { useModifySearch } from './hooks/useModifySearch'
import Autocomplete from 'react-autocomplete';
import { useSelector } from 'react-redux';

const ModifySearch = () => {
    const lang = useSelector((state) => state.culture.language);
    const { countryNames, handleSearch } = useModifySearch();
    const [selectedCountry, setSelectedCountry] = useState("");
    const [inputValue, setInputValue] = useState("");


    const handleClear = () => {
        setInputValue('')
        setSelectedCountry('')
    }

    return (
        <section className="inner_banner">
            <div className="container">
                {/*package rslt start here*/}
                <div className="spackagersltmodify d-flex flex-wrap align-items-center">
                    <div className="col-lg-6 mobpad-0">
                        <div className="d-flex flex-wrap align-items-center">
                            <div className="htl_location loc_icon">
                                <Autocomplete

                                    items={countryNames}
                                    getItemValue={(item) => item}
                                    renderItem={(item, isHighlighted) => (
                                        <div
                                            key={item}
                                            style={{
                                                padding: "10px",
                                                background: isHighlighted ? "#eee" : "#fff",
                                                cursor: "pointer",
                                            }}
                                        >
                                            {item}
                                        </div>
                                    )}
                                    value={inputValue}
                                    onChange={(e) => setInputValue(e.target.value)}
                                    onSelect={(val) => {
                                        setInputValue(val);
                                        setSelectedCountry(val);
                                    }}
                                    inputProps={{
                                        placeholder: lang.choose_country,
                                        className: "form-control",
                                    }}
                                    menuStyle={{
                                        backgroundColor:'red',
                                        borderRadius: "5px",
                                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                        padding: "0",
                                        position: "absolute",
                                        zIndex: 8,
                                        background: "#fff",
                                        width: "100%",
                                        top:'50px',
                                        left:'0',
                                    }}
                                />
                                {selectedCountry && 
                                <button class="clear_btn" id="close_from_city " onClick={handleClear}></button>
                                }
                            </div>
                            <div className="serBtnArea">
                                <button type="button" className="htlmodifybtn" onClick={() => handleSearch(selectedCountry)}>
                                    {" "}
                                    {lang.search}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 mobpad-0">
                        <nav aria-label="breadcrumb" className="sppackBreadcumb">
                            <ol className="breadcrumb d-flex flex-wrap  align-items-center justify-content-end">
                                <li className="breadcrumb-item active" aria-current="page">
                                    {lang.select_packages}{" "}
                                </li>
                                <li className="breadcrumb-item" aria-current="page">
                                    {" "}
                                    {lang.passenger_details}{" "}
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                {/*hotel search end here*/}
            </div>
        </section>

    )
}

export default ModifySearch